import { render, staticRenderFns } from "./JoinUs.vue?vue&type=template&id=31575542&scoped=true&"
import script from "./JoinUs.vue?vue&type=script&lang=ts&"
export * from "./JoinUs.vue?vue&type=script&lang=ts&"
import style0 from "./JoinUs.vue?vue&type=style&index=0&id=31575542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31575542",
  null
  
)

export default component.exports